import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addBatchApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addBatch = createAsyncThunk('addBatch', async (payload) => {
  return await addBatchApi(payload);
});

const addBatchSlice = createSlice({
  name: 'addBatch', // Unique Name
  initialState,
  reducers: {
    addBatchReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addBatch.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addBatch.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addBatch.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addBatchReset } = addBatchSlice.actions;

export default addBatchSlice.reducer;
